// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","logo":"Footer_logo__+JiYo","welcome":"Footer_welcome__jy-L8"};